export function getMaxWidth(data) {
    const mobileMaxWidth = parseInt(data.mobileMaxWidth) || null
    const tabletMaxWidth = parseInt(data.tabletMaxWidth) || mobileMaxWidth
    const desktopMaxWidth = parseInt(data.desktopMaxWidth) || tabletMaxWidth

    return {
        mobile: mobileMaxWidth,
        tablet: tabletMaxWidth,
        desktop: desktopMaxWidth,
    }
}
